<template>
  <div :style="{ height, width }" id="EchartsGG" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data:function () {
    return {
      echartsData:{
        "size":21,
        "list":[
          {"nongyao":"100","mc":"用水量","huafei":"75",unit:"吨"},
          {"nongyao":"100","mc":"用肥量","huafei":"83.3",unit:"公斤"},
          {"nongyao":"100","mc":"农药量","huafei":"66.6",unit:"公斤"},

        ]
      }
    }
  },
  mounted(){
    this.loadEchartsAnimate()
  },
  methods:{
    chartsRelativeSize(percent, derection) {
      var windowW = this.$refs.docement.offsetWidth;
      var windowH = this.$refs.docement.offsetHeight
      var r = 0;
      if ('h' === derection) {
        r = percent * windowH / 100;
      } else {
        r = percent * windowW / 100;
      }
      return r;
    },
    loadEchartsAnimate(){
      var that = this
      var echarts = require('echarts');
      var myCharts = echarts.init(document.getElementById('EchartsGG'));
      let color = ['#407FFF','#00FFBA']
      var option = {
        color:['#407FFF','#00FFBA'],
        tooltip : {
          trigger: 'axis',
          textStyle:{
            color:'#000',
            fontSize:14
          },
          // formatter: (params) => {
          //   let arr = [...params];
          //   let str = '';
          //   arr.forEach((item, index) => {
          //     str += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' +
          //       color[index] +
          //       ';"></span>' + item.seriesName + ' : ' + item.data  + '<br />';
          //   });
          //   str = arr[0].name + '<br />' + str;
          //   return str;
          // },
        },
        grid: {
          left: '5%',
          right: '25px',
          bottom: '5%',
          top:'20%',
          containLabel: true
        },
        legend: {
          orient: 'horizontal',
          top:'3%',
          right: '20px',
          itemWidth:26,
          itemHeight:19,
          icon:"rect",
          textStyle:{
            color:'#fff',
            fontSize: 14,
            padding: [0, 0, 0, 10]
          },
          data:['普通农田','高标农田'],
          z:10001

        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#1D4459',//左边线的颜色
                width: '2'//坐标线的宽度
              }
            },
            axisLabel: {
              textStyle: {
                color: '#fff',//坐标值得具体的颜色,
                fontSize: 14
              },
              interval:0
            },
            axisTick:false,
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show:true,
              lineStyle: {
                type: 'solid',
                color: '#1D4459',//左边线的颜色
                width: '2'//坐标线的宽度
              }
            },
            axisLabel: {
              show:true,
              textStyle: {
                color: '#e6e6e6',//坐标值得具体的颜色,
                fontSize:14
              }
            },
            axisTick:false,
            splitLine: {  //坐标轴在grid区域中的分隔线（网格中的横线）
              show: true,
              lineStyle: {
                color: '#104557',
                width: 1,
                type: 'solid',
              }
            }
          }
        ],
        series : [
          {
            name:'普通农田',
            type:'bar',
            barGap:0.5,
            barWidth:20,
            data:[],
            itemStyle: {
              normal: {
                // //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                // barBorderRadius:[5, 5, 5, 5],
                borderColor: '#35C5C8',
                color:new echarts.graphic.LinearGradient( 0,1,0,0,[
                    { offset: 0, color: '#41C6FE' },
                  { offset: 0.5, color: 'rgba(60,188,255,0)' },
                    { offset: 1, color: 'rgba(60,188,255,0)' }
                  ],
                )}
            },
          },{
            name:'高标农田',
            type:'bar',
            barGap:0.5,
            barWidth:20,
            data:[],
            itemStyle: {
              normal: {
                //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                // barBorderRadius:[5, 5, 5, 5],
                borderColor: '#35C5C8',
                color:new echarts.graphic.LinearGradient( 0,1,0,0,[
                    { offset: 0, color: '#2AF4F5' },
                  { offset: 0.5, color: 'rgba(69,255,253,0)' },
                    { offset: 1, color: 'rgba(69,255,253,0)' }
                  ],
                )}

            }
          }
        ]
      };
      for(var i=0;i<this.echartsData.list.length;i++){
        option.xAxis[0].data.push( that.echartsData.list[i].mc);
        option.series[0].data.push( that.echartsData.list[i].nongyao);
        option.series[1].data.push( that.echartsData.list[i].huafei);
      }
      myCharts.setOption(option);


    }
  }
}
</script>
<style lang="less">
.min-body{
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #010827;
}

</style>
